<div class="sidebar-content">

  <!-- Chevron logo -->
  <img class="hallmark" src="images/sidebar/cvx_logo.png" alt="chevron logo" />


  <!-- Buttons -->

  <a class="link-button" href="https://go.chevron.com/exploration" target="_blank" rel="noopener noreferrer">
    <img src="images/sidebar/hub.png" alt="hub" />
    <p class="img-text">hub</p>
  </a>

  <a class="link-button" href="https://go.chevron.com/exploreprospect" target="_blank" rel="noopener noreferrer">
    <img src="images/sidebar/prospect.png" alt="prospect" />
    <p class="img-text">prospect</p>
  </a>

  <a class="link-button" href="https://go.chevron.com/eXploreMaps" target="_blank" rel="noopener noreferrer">
    <img src="images/sidebar/maps.png" alt="maps" />
    <p class="img-text">maps</p>
  </a>

  <a class="link-button" href="https://go.chevron.com/exploredocs" target="_blank" rel="noopener noreferrer">
    <img src="images/sidebar/docs.png" alt="docs" />
    <p class="img-text">docs</p>
  </a>

  <a class="link-button" href="https://go.chevron.com/analogs" target="_blank" rel="noopener noreferrer">
    <img src="images/sidebar/analog.png" alt="analogs" />
    <p class="img-text">analogs</p>
  </a>

  <a class="link-button" href="https://go.chevron.com/exploreexcap" target="_blank" rel="noopener noreferrer">
    <img src="images/sidebar/excap.png" alt="excap" />
    <p class="img-text">excap</p>
  </a>

  <a class="link-button" href="https://go.chevron.com/explorebasins" target="_blank" rel="noopener noreferrer">
    <img src="images/sidebar/basins.png" alt="basins" />
    <p class="img-text">basins</p>
  </a>

  <a class="link-button" href="https://go.chevron.com/exploretracker" target="_blank" rel="noopener noreferrer">
    <img src="images/sidebar/etracker.png" alt="tracker" />
    <p class="img-text">tracker</p>
  </a>


</div>
